import React from 'react';
import { Dialog } from '../../../../../../../../components/Dialog';
import { Images } from '@ansvar-sakerhet/ui/src/assets/images';
import { S } from './ConfirmDeleteDialog.styles';

type Props = {
  isOpen: boolean;
  title: string;
  description: string;
  isLoading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

export const ConfirmDeleteDialog: React.FC<Props> = (props) => {
  return (
    <Dialog.Provider isOpen={props.isOpen}>
      <Dialog.Base onClose={props.onClose}>
        <img src={Images.Delete} width={295} height={215} />

        <Dialog.Title>
          <S.H5>{props.title}</S.H5>
        </Dialog.Title>

        <Dialog.Description>
          <S.H6>{props.description}</S.H6>
        </Dialog.Description>

        <S.ButtonContainer>
          <Dialog.CancelButton>
            <S.Button
              $outlined
              onClick={(e) => {
                e.stopPropagation();
                props.onClose();
              }}
            >
              Avbryt
            </S.Button>
          </Dialog.CancelButton>

          <Dialog.Button>
            <S.Button
              disabled={props.isLoading}
              onClick={(e) => {
                e.stopPropagation();
                props.onConfirm();
              }}
            >
              Ja, radera
            </S.Button>
          </Dialog.Button>
        </S.ButtonContainer>
      </Dialog.Base>
    </Dialog.Provider>
  );
};
